import styled, { css } from 'styled-components';

const LoadingWrapper = styled.div`
  align-items: center;
  background: white;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  opacity: 1;
  position: fixed;
  top: 0;
  transition: all 0.3s ease-in-out;
  visibility: visible;
  width: 100%;
  z-index: 1050;

  ${({ loaded }) =>
    loaded &&
    css`
      opacity: 0;
      visibility: hidden;
      z-index: 1;
    `}
`;

const Bouncer = styled.div`
  width: 16px;
  height: 16px;
  background-color: #333;
  margin: 0 5px;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  transform-origin: center center;

  &:first-child {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  &:nth-child(2) {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }

  @-webkit-keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
    }
  }

  @keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }

  @-webkit-keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1);
    }
  }
`;

export { LoadingWrapper, Bouncer };
